import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import SiteLayout from './components/site/SiteLayout';
import { SiteProvider } from './context/SiteContext';
import HomePage from './pages/HomePage';
import InvitePage from './pages/InvitePage';
import LeaderboardPage from './pages/LeaderboardPage';
import NotFoundPage from './pages/NotFoundPage';
import PlayPage from './pages/PlayPage';
import PrivacyPage from './pages/PrivacyPage';
import ProfilePage from './pages/ProfilePage';
import TermsPage from './pages/TermsPage';

const App: React.FC = () => {
  return (
    <SiteProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SiteLayout />}>
            <Route index element={<HomePage />} />
            <Route path="play" element={<PlayPage />} />
            <Route path="leaderboard" element={<LeaderboardPage />} />
            <Route path="invite" element={<InvitePage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="terms" element={<TermsPage />} />
            <Route path="privacy" element={<PrivacyPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </SiteProvider>
  );
};

export default App;